import request from '@/util/server.js'
// 登录模块

// 获取验证码
export function getTheCode (params) {
  return request({
    url: '/app/getCode',
    method: 'get',
    params
  })
}

// 登录
export function login (data) {
  return request({
    url: '/app/login',
    method: 'post',
    data
  })
}

// 第三方注册跳转 URL
export function getThirdPartyRegisterUrl () {
  return request({
    url: '/dict/getByName',
    method: 'get',
    params: { name: 'third_register_url_pc' }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js